import { render } from "./NotFoundError.vue?vue&type=template&id=782798a5&scoped=true"
const script = {}

import "./NotFoundError.vue?vue&type=style&index=0&id=782798a5&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-782798a5"],['__file',"src/components/errors/NotFoundError.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "782798a5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('782798a5', __exports__)) {
    api.reload('782798a5', __exports__)
  }
  
  module.hot.accept("./NotFoundError.vue?vue&type=template&id=782798a5&scoped=true", () => {
    api.rerender('782798a5', render)
  })

}


export default __exports__